import { gql } from "@apollo/client";

export const GET_EXPORT_PROVEEDOR_DISTRIBUIDOR = gql`
query GetExportProveedorDistribuidor{
    exportProveedorDistribuidor
    {
        idProveedorDistribuidor,
        codigoSAP,
        razonSocial,
        contacto,
        telefonoAdicional,
        observacion,
        activo,
        email,
        idDepositoNavigation {
            idDeposito,
            descripcion
        },
        proveedorMetodoCobroBulto{
            idProveedorMetodoCobroBulto,
            fechaDesde,
            fechaHasta
        },
        proveedorMetodoCobroKM{
            idProveedorMetodoCobroKM,
            fechaDesde,
            fechaHasta
        },
        proveedorMetodoCobroKilo{
            idProveedorMetodoCobroKilo,
            fechaDesde,
            fechaHasta
        }
    }
}`;